// extracted by mini-css-extract-plugin
export default {"chart":"ChartTotalLearners_chart__k9J7V","gtitle":"ChartTotalLearners_gtitle__hue08"};